/** 特定角色的特殊规则控制 */

import { useUserStoreWithoutSetup } from '@/store/modules/user'
/**
 * 角色大类枚举
 * @date 2022/06/15
 */
export enum ROLE_TYPE {
  /** 系统管理员 */
  ADMIN = '系统管理员',
  /** 商务经理 */
  BUSINESS = '商务经理',
  /** 摇钱树货主 */
  SUPPLIER = '供应商'
}

/**
 * 是否展示货主信息
 * 摇钱树货主 不显示
 * 非摇钱树货主 显示
 */
export function showSupplierDetail() {
  const userStore = useUserStoreWithoutSetup()
  const userInfo = userStore.getUserInfo
  if (!userInfo) return false
  const { roleTypeName } = userInfo
  return roleTypeName !== ROLE_TYPE.SUPPLIER
}
